<div class="app-advertisement">
  <div [ngStyle]="{'min-width':adObj?.minWidth, 'min-height':adObj?.minHeight}"  class="ad-{{ this.type }}" [id]="getAdvertisementId()"></div>
</div>
